export default __webpack_public_path__ + "static/media/transport-benefit.dfb8cb3f.png";